export function getErrorMessage(error: Error): string {
  // TODO: Parse axios response errors
  return error.message;
}
